import React from 'react';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { AuthProvider } from './context/AuthContext';
import Login from './components/Login';
import ProductList from './components/ProductList';
import Cart from './components/Cart';
import './App.css';

function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <div className="container">
          <div className="header">
            <h1>State Management Demo</h1>
            <p>Context API for Authentication + Redux Toolkit for Products & Cart</p>
          </div>
          
          <Login />
          
          <div className="main-content">
            <ProductList />
            <Cart />
          </div>
        </div>
      </AuthProvider>
    </Provider>
  );
}

export default App;